import { getCookieValue } from '@libs/common-next';
import { dataLayerPush } from '../gtm';
import type { EventContractMap } from '../types/analyticsEvents';

export const Analytics = {
    on<Event extends keyof EventContractMap>(action: Event, data: EventContractMap[Event]): void {
        dataLayerPush({ ...data, event: action });
    },
};

/**
 * Extracts the user ID from the Google Analytics device ID.
 * @example `GA1.1.xxxxxxxxxx.xxxxxxxxxx => xxxxxxxxxx-xxxxxxxxxx`
 * @link https://support.google.com/analytics/answer/11397207
 */
function extractGoogleAnalyticsUserIdFromCookie(gaCookie: string) {
    if (gaCookie) {
        // Remove the Google Analytics tracker from the device ID.
        const userIdParts = gaCookie.split('.').slice(-2);
        if (userIdParts.length === 2) {
            return userIdParts.join('-');
        }
    }
    return undefined;
}

/**
 * Returns the Google Analytics User ID from a browser cookie name.
 * @example `getGoogleAnalyticsUserIdFromBrowserCookie('_ga')`
 */
export function getGoogleAnalyticsUserIdFromBrowserCookie(cookieName: string) {
    const browserCookie = getCookieValue(cookieName);

    if (!browserCookie) {
        return undefined;
    }

    return extractGoogleAnalyticsUserIdFromCookie(browserCookie);
}
